import toast from "react-hot-toast";
import { authFetch } from "../../api/authFetch";
import CustomToast from "../../components/ui/custom-toast";
import { ToastTypeEnum } from "./enums/toast";

export async function deleteArrFunc(
  queryArr: number[],
  request: string,
  setIsDeleted: React.Dispatch<React.SetStateAction<boolean>>,
  keyName?: string,
) {
  const body = keyName
    ? { [keyName]: queryArr }
    : queryArr;
  const response = await authFetch(request, {
    method: (request.toLocaleLowerCase().includes("task") || request.toLocaleLowerCase().includes("finance")) ? "DELETE" : "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  if (response.ok) {
    toast((t) => (
      <CustomToast
        t={t}
        type={ToastTypeEnum.INFO}
        text={"Видалення успішне."}
      />
    ));
    setIsDeleted(true);
  }

  if (response.status === 404) {
    toast((t) => (
      <CustomToast
        t={t}
        type={ToastTypeEnum.INFO}
        text={"Видалення не можливе.\nНемає доступу!"}
      />
    ));
  }
}
